// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { headerLinkListStyles } from "@guestsupply/Overrides/Widgets/Header/HeaderLinkList";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        &&&& {
            .active {
                display: inline-block;
                background-color: ${getColor("common.ui2")};

                .list-link {
                    > ${TypographyStyle} {
                        margin-top: -1px;
                        padding-top: 17px;
                        height: 51px;
                        box-shadow: inset 0 2px 0 0 ${getColor("common.ui9")};
                    }
                }

                span {
                    color: ${getColor("text.link")};
                }
                ${IconWrapper} {
                    transform: rotate(180deg);
                }
            }
        }
    `,
};
headerLinkListStyles.link = {
    typographyProps: {
        size: 16,
        weight: 500,
        css: css`
            &&& {
                color: ${getColor("text.main")};
                display: flex;
                align-items: center;
                height: 50px;
                padding: 16px;
                text-transform: uppercase;
                overflow: hidden;
                &:hover,
                &:active {
                    background-color: ${getColor("common.ui2")};
                    box-shadow: inset 0 2px 0 0 ${getColor("common.ui9")};
                    color: ${getColor("common.ui9")};
                    margin-top: -1px;
                    padding-top: 17px;
                    height: 51px;
                }
                ${xScreen("lte", 1133)} {
                    padding: 16px 8px;
                }
                ${xScreen("lte", 1065)} {
                    padding: 16px 4px;
                }
            }
        `,
    },
};
headerLinkListStyles.linkList = {
    css: css`
        &&& {
            display: flex;
            align-items: center;
            line-height: 19px;
            font-size: 14px;
            padding: 4px 8px;
            font-weight: 400;
            width: 100%;
            span {
                line-height: 21px;
                font-weight: 400;
                color: ${getColor("text.main")};
            }
            &:hover,
            &:focus,
            &:active {
                background-color: ${getColor("common.ui2")};
                box-shadow: inset 2px 0 0 0 ${getColor("common.ui9")};
                span {
                    color: ${getColor("common.ui9")};
                }
            }
        }
    `,
};
headerLinkListStyles.menuItemIcon = {
    size: 11,
    color: "text.link",
    css: css`
        margin: auto 0 auto 10px;
        &&& {
            svg {
                color: ${getColor("text.link")};
            }
        }
    `,
};
headerLinkListStyles.parentLink = {
    color: "text.main",
    css: css`
        margin: 9px 0 8px 9px;
        ${TypographyStyle} {
            font-weight: 500;
            line-height: 21px;
        }
    `,
};
headerLinkListStyles.tippyPopup = {
    main: {
        css: css`
            &.tippy-box {
                border-radius: 0;
                box-shadow: none;
            }
        `,
    },
};
headerLinkListStyles.linkListWrapper = {
    css: css`
        padding: 9px;
        width: 300px;
    `,
};
